import { render } from "./NcrmWorkflowStagingDrawer.vue?vue&type=template&id=b60b86f6&scoped=true"
import script from "./NcrmWorkflowStagingDrawer.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowStagingDrawer.vue?vue&type=script&lang=js"

import "./NcrmWorkflowStagingDrawer.vue?vue&type=style&index=0&id=b60b86f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b60b86f6"]])

export default __exports__